module.exports = __webpack_public_path__ + "img/home.d9379d8d.jpg";